export const iconFontAwesomeCharityGift = (
	<i className="fa-solid fa-gift"></i>
);
